<template>
    <div class="one-popover" :class="[{ 'one-popover--rtl': rtl }, className]" :style="style">
        <slot name="target"></slot>
        <Popover
            :target="target"
            :position="position"
            :disabled="disabled"
            :showCloseIcon="showCloseIcon"
            :closeIcon="closeIcon"
            :autoZIndex="autoZIndex"
            :baseZIndex="baseZIndex"
            :appendTo="appendTo"
            :scrollableParents="scrollableParents"
            @show="onShow"
            @hide="onHide"
        >
            <slot></slot>
        </Popover>
    </div>
</template>

<script setup lang="ts">
import Popover from 'primevue/popover'
import type { PopoverProps, PopoverEmits } from './types'

const props = withDefaults(defineProps<PopoverProps>(), {
    target: undefined,
    position: 'right',
    disabled: false,
    showCloseIcon: false,
    closeIcon: 'pi pi-times',
    autoZIndex: true,
    baseZIndex: 0,
    appendTo: 'body',
    scrollableParents: () => [],
    style: undefined,
    className: undefined,
    rtl: false
})

const emit = defineEmits<PopoverEmits>()

// Event handlers
const onShow = () => emit('show')
const onHide = () => emit('hide')
</script>

<style lang="scss">
.one-popover {
    &--rtl {
        direction: rtl;
    }
}
</style>
